export const handleClearFilterChipData = <T extends Record<string, unknown>>(
  newFilter: T,
  key: keyof T,
  value?: string
): T => {
  if (key === "changeType" || key === "productManagerId") {
    newFilter = {
      ...newFilter,
      changeType: undefined,
      supplierId: undefined,
      customerIds: undefined,
      productCategoryId: undefined,
      productClassId: undefined,
      specificProductIds: undefined,
      productManagerId: undefined,
      shipFromId: undefined,
      shipToId: undefined,
      effectiveDate: undefined,
      page: undefined,
    }
  } else if (Array.isArray(newFilter[key])) {
    ;(newFilter[key] as string[]) = (newFilter[key] as string[]).filter((item) => item !== value)
    if ((newFilter[key] as string[]).length === 0) {
      newFilter[key] = undefined as unknown as T[keyof T]
    }
  } else {
    newFilter[key] = undefined as unknown as T[keyof T]
  }

  return newFilter
}
